export enum TOOOLTIP_WIDTHS {
  MaxTooltipWodthForAutocomplete = "312px",
}
